import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config' //hxn
/* 
 hxn add
 */
// import { constantRouterMap, asyncRouterMap } from '@/config/router.config'
//Object.assign(asyncRouterMap,constantRouterMap)

// hack router push callback
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)
console.log('process.env.BASE_URL>>', process.env.BASE_URL)
const createRouter = () =>
  // history 需要配置nginx
  // location / {
  //   try_files $uri $uri/ /index.html;
  // }
  new Router({
    mode: 'history',
    routes: constantRouterMap, //hxn--remove premission
    // routes: constantRouterMap.concat(asyncRouterMap),
    base: '/',
    scrollBehavior: () => ({ y: 0 }),
  })

const router = createRouter()

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
